import { RootState } from 'editor/src/store/index';

import { alwaysVisibleWarningTypes } from './getVisibleWarnings';

const getVisibleWarningsCount = (state: RootState) => {
  const { hiddenWarnings, showWarningsOnlyAfterDesignRequest } = state.hostSettings;
  return state.editorModules.warnings.list.reduce((acc, warning) => {
    if (hiddenWarnings[warning.type]) {
      return acc;
    }
    if (showWarningsOnlyAfterDesignRequest && !alwaysVisibleWarningTypes.has(warning.type)) {
      return acc;
    }
    return acc + 1;
  }, 0);
};

export default getVisibleWarningsCount;
